import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { ProcessoService } from '@app/services/processo.service';
import { from, forkJoin, Observable, throwError, of } from 'rxjs';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { ProcessoDocumento } from '@app/models/processo-documento.model';

import { Input, HostListener } from '@angular/core';
import { UploadFileDocumento, UploadStatusNome } from './upload-file';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { UploadFileSasUrl } from '@app/models/upload-file-sas-url';
import { AzureStorageService } from '@app/services/azure-storage.service';
import { BlobServiceClient, BlockBlobUploadOptions, ContainerClient } from '@azure/storage-blob';
import { mergeMap, take, map, catchError, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-documentos-form',
  templateUrl: './documentos-form.component.html',
  styleUrls: ['./documentos-form.component.scss']
})
export class DocumentosFormComponent implements OnInit {

  processoId: number = 0;
  lstDocumentos: Array<IdDescricao> = [];
  lstSubCategorias: Array<IdDescricao> = [];
  documentoId: any = '';
  subcategoria: any = '';
  somenteDesdeProcesso: boolean = true;
  lstErros: string[] = [];
  anexoId: number = 0;
  lstProcessoAnexo: Array<ProcessoAnexo> = [];
  arquivoAbaixo20MB: boolean = true;
  bsModalRef: BsModalRef;
  subCategoriaId: any = '';
  tipoDocumentoId: any = '';
  aguardandoSolicitacao: boolean = false;
  modoEdicao: boolean = false;
  TAMANHO_MAX_20MB = 20 * 1024 * 1024;
  TAMANHO_MAX_1GB = 1 * 1024 * 1024 * 1024;

  get tamanhoMaximoArquivo(): number {
    return this.arquivoAbaixo20MB ? this.TAMANHO_MAX_20MB : this.TAMANHO_MAX_1GB;
  }

  get mensagemTamanhoMaximoExcedido(): string {
    return `Tamanho de arquivo superior a ${this.arquivoAbaixo20MB ? '20 MB' : '1 GB'}`;
  }

  @Input() fileList: Array<UploadFileDocumento> = [];
  @Input() lstProcessoAnexoSelecionados: Array<ProcessoAnexo> = [];
  @Input() arquivosConcluidos: Array<UploadStatusNome> = [];
  @Input() aparecerEditar: boolean = false;


  public uploadProgress: number = 0;
  public carregandoDocumentos: boolean = false;

  get mostrarAreaUpload(): boolean {
    return this.arquivoAbaixo20MB || this.fileList.length === 0;
  }

  @HostListener('dragover', ['$event']) onDragOver(event) {
    event.preventDefault();
  }
  @HostListener('dragenter', ['$event']) onDragEnter(event) {
    event.preventDefault();
  }
  @HostListener('dragend', ['$event']) onDragEnd(event) {
    event.preventDefault();
  }
  @HostListener('dragleave', ['$event']) onDragLeave(event) {
    event.preventDefault();
  }
  @HostListener('drop', ['$event']) onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer.files;
    this.saveFiles(files);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private azureStorageService: AzureStorageService,
    private toastrService: ToastrService,
    public modalService: BsModalService
  ) { }

  ngOnInit() {
    this.reajustaScrollParaInicio();
    this.inicializarParametrosDaRota();
    this.carregarListas();

    if (this.modoEdicao){
      this.carregarDocumento();
    }
  }

  reajustaScrollParaInicio(): void {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  inicializarParametrosDaRota(): void {
    const idParametroProcesso = this.route.parent?.snapshot.paramMap.get('id');
    const idParametroDocumento = this.route.snapshot.paramMap.get('id');

    this.processoId = idParametroProcesso ? +idParametroProcesso : 0;
    this.documentoId = idParametroDocumento ? +idParametroDocumento : 0;
    this.modoEdicao = this.documentoId !== null && this.documentoId !== undefined && this.documentoId !== 0;
  }

  carregarDocumento(): void {
    this.processoService.obterDocumentoPorId(this.documentoId).toPromise().then(
      data => {
            this.documentoId = data.Id;
            this.subCategoriaId = data.subCategoriaId;
            this.tipoDocumentoId = data.TipoDocumentoId;
            this.somenteDesdeProcesso = data.SomenteDesdeProcesso;
      }
    )
    .catch(
      () => this.router.navigate([`./processos/processo/${this.processoId}/documentos`])
    );
  }

  async carregarListas(): Promise<void> {
    try {
      const [documentos, subCategorias] = await Promise.all([
        this.consultasService.consultar('DOCUMENTO').pipe(take(1)).toPromise(),
        this.consultasService.consultar('SUBCATEGORIA').pipe(take(1)).toPromise()
      ]);

      this.lstDocumentos = documentos;
      this.lstSubCategorias = subCategorias;

    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  }

  modificaFluxoArquivo(enviarArquivoPequeno: boolean): void {
    if(enviarArquivoPequeno === this.arquivoAbaixo20MB) return; //Usuario clicou na opção já ativa, nao fazer nada

    if(this.fileList.length === 0) {
      this.arquivoAbaixo20MB = !this.arquivoAbaixo20MB;
      return;
    }

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente mudar a opção de upload de arquivos ?
    Todos os arquivos inseridos serão deletados !`
    this.bsModalRef.content.confirmar = () => {
      this.arquivoAbaixo20MB = !this.arquivoAbaixo20MB;
      this.fileList = [];
    };

  }

  async gravar() {
    this.aguardandoSolicitacao = true;

    if (this.modoEdicao) {
      const processoDocumento = this.criarDTODocumento();
      this.processoService.atualizarDocumento(processoDocumento).toPromise().then(
        data => {
          this.router.navigate([`./processos/processo/${this.processoId}/documentos`]);
        }
      );
    }
    else {
      this.adicionarArquivos();
    }

  }

  criarDTODocumento() : ProcessoDocumento {
    return new ProcessoDocumento({
      Id: this.documentoId,
      SubcategoriaId: this.subCategoriaId,
      TipoDocumentoId: this.tipoDocumentoId,
      SomenteDesdeProcesso: this.somenteDesdeProcesso
    });
  }

  exibirLoading(mostrar: boolean) {
    const overlay = document.getElementById('overlay');
    if(overlay){
      overlay.style.display = mostrar ? 'block' : 'none';
    }
  }

  adicionarArquivos() {

    if(!this.fileList || this.fileList.length === 0) return;
    
    const temArquivoInvalido = this.fileList.some(item => item.File.size > this.tamanhoMaximoArquivo);

    if(temArquivoInvalido){
      this.fileList.forEach(item => {
        if (item.File.size > this.tamanhoMaximoArquivo) {
          this.toastrService.error(item.File.name, this.mensagemTamanhoMaximoExcedido);
        }
      });

      return;
    }
    
    this.exibirLoading(true);

    const listaUploads$ = this.fileList.map(
      arquivo => {
      const processoDocumento = this.AdicionaInformacoesDoDocumento(arquivo);
      return this.AdicionandoArquivoViaSasNoStorage(processoDocumento, arquivo);
    });

    forkJoin(listaUploads$).subscribe({
      next: () => {
        this.router.navigate([`./processos/processo/${this.processoId}/documentos`]);
      },
      error: (error) => {
        console.error('Erro no upload de arquivos:', error);
        this.toastrService.error('Falha ao enviar um ou mais arquivos.');
      },
      complete: () => {
        this.exibirLoading(false);
      }
    });
  }

  AdicionaInformacoesDoDocumento(UploadFileItem: UploadFileDocumento): ProcessoDocumento {
    let fileNameArray: string[] = UploadFileItem.File.name.split('.');
    let processoDocumento = new ProcessoDocumento(
      {
        ProcessoId: this.processoId,
        ArquivoNome: UploadFileItem.File.name,
        Descricao:  UploadFileItem.Descricao,
        Subcategoria: UploadFileItem.subcategoriaModel,
        TipoDocumentoId: UploadFileItem.documentoIdModel,
        SomenteDesdeProcesso: UploadFileItem.somenteDesdeProcessoModel,
        Extensao: fileNameArray[fileNameArray.length - 1]
      }
    );

    return processoDocumento;
  }

  AdicionandoArquivoViaSasNoStorage(processoDocumento: ProcessoDocumento, arquivo: UploadFileDocumento): Promise<void> {
    return this.processoService.gravarObtendoSas(processoDocumento, "documentos").pipe(
      switchMap(sasData => this.azureStorageService.realizarUploadAzure(sasData, arquivo)),
      switchMap((idDocumento: number) => this.verificarUpload(idDocumento, arquivo))
    )
    .toPromise()
    .then(() => { 
    })
    .catch(error => {
      this.lidarComFalhaDeUpload();
    });
  }

  private verificarUpload(idDocumento: number, upload: UploadFileDocumento): Observable<void> { 
    return this.processoService.verificaExistenciaArquivoDocumentos(idDocumento, "documentos").pipe(
      switchMap(existenciaArquivo => {
        if (existenciaArquivo) {
          upload.progress = 100;
          return of(void 0);
        }
        
        throw new Error("Erro ao verificar upload.");
      }),
      catchError(error => {
        return this.processoService.deletarDocumento(idDocumento).pipe(
          map(() => {
            throw error;
          }),
          catchError(() => {
            throw error;
          })
        );
      })
    );
  }

  private extrairIdDocumento(nomeArquivo: string): number {
    const idString = nomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2");
    return Number.parseInt(idString, 10);
  }

  private lidarComFalhaDeUpload(): void {
    this.toastrService.error("Não foi possível realizar o upload!");
    this.exibirLoading(false);
    this.aguardandoSolicitacao = false;
  }

  onFileChange(event) {
    const files = event.target.files;
    this.saveFiles(files);
  }

  saveFiles(files): void {
    if(files.length <= 0)
      return;

    if (this.arquivoAbaixo20MB) {
      this.salvarArquivosPequenos(files);
    }
    else {
      if (this.fileList.length > 0) return;

      this.salvarUnicoArquivoGrande(files);
    }
  }

  private salvarArquivosPequenos(files) {
    for (let j = 0; j < files.length; j++) {
      const arquivo = new UploadFileDocumento();
      arquivo.File = files[j];
      if (arquivo.File.size > 20971520){
        this.toastrService.error(arquivo.File.name, "Arquivo maior que 20MB");
        return;
      }
      arquivo.Descricao = arquivo.File.name.split('.').slice(0, -1).join('.');
      this.fileList.push(arquivo);
    }
  }

  private salvarUnicoArquivoGrande(files): void {
    const arquivo = new UploadFileDocumento();
    arquivo.File = files[0];
    arquivo.Descricao = arquivo.File.name.split('.').slice(0, -1).join('.');
    this.fileList.push(arquivo);
  }

  public calculaTamanho(tamanho: number) {
    return this.formatFileSize(tamanho, 1);
  }


  formatFileSize(bytes, decimalPoint) {
    if (bytes === 0) { return '0 Bytes'; }
    const k = 1024,
      dm = decimalPoint || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deletar(i: number) {
    this.fileList.splice(i, 1);
  }
}
